export const readingGoalCopy = {
  en: {
    journey: {
      thisWeek: 'this week',
      ofTarget: 'of {{target}}',
      bySunday: '{{count}} more by Sunday',
      weekReached: 'This week’s goal reached',
      todayProgress: 'Today {{current}} of {{target}}',
      noGoalHistory: '{{count}} pages logged this week. Your history stays either way.',
      pagesAccessibility:
        'Reading goal: {{current}} of {{target}} pages this week, today {{today}} of {{daily}}',
      pace: { ahead: 'Ahead of pace', on: 'On pace', behind: 'A little behind' },
      booksRhythm_one: '~{{count}} page a day',
      booksRhythm_other: '~{{count}} pages a day',
      booksAhead: 'You’re ahead',
      booksSoFar_one: '{{count}} book this year',
      booksSoFar_other: '{{count}} books this year',
      booksGoalTarget_one: 'Goal: {{count}} book',
      booksGoalTarget_other: 'Goal: {{count}} books',
      booksCount_one: '{{current}} / {{count}} book',
      booksCount_other: '{{current}} / {{count}} books',
      readingDays: 'Reading days this week: {{count}}',
    },
    edit: 'Edit',
    ofBooks: 'of {{target}} books',
    title: 'Reading goal',
    books: 'Books a year',
    pages: 'Pages a day',
    historyKept: 'Changing your goal keeps all your reading history.',
    booksInYear: 'books in {{year}}',
    pagesPerDay: 'pages a day',
    average: 'An average. Some days more, some less.',
    exact: 'Enter an exact number',
    keyboard: 'Opens the numeric keyboard.',
    booksRange: 'Type any number from 1 to 999.',
    pagesRange: 'Enter a positive whole number.',
    invalidPages: 'Choose a whole number from 1 to 1,000,000.',
    finishedSoFar: '{{count}} finished so far',
    rulerHint: 'Swipe to adjust. Tap the number to type.',
    done: 'Done',
    save: 'Save goal',
    addsUp: 'Adds up to',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    equivalent: '{{count}} pages · {{range}}',
    starts: 'Starts {{date}}. Nothing to catch up.',
    existingStart: 'Counted from {{date}}. Earlier reading stays in your history.',
    whatCounts: 'What counts?',
    everyPage: 'Every page you log counts, across all books and every update.',
    flexible: 'It’s an average. A long read one day can balance a quiet one.',
    late: 'Logged late? It counts on the day you save it.',
    noTimers: 'No timers or sessions. Just the page updates you already make.',
    gotIt: 'Got it',
    calendar: 'Reading calendar',
    openMonth: 'Open {{month}}',
    today: 'Today',
    ofPages: '{{current}} of {{target}} pages',
    dailyPace: '{{count}} pages a day',
    bySunday: '{{count}} more by Sunday. Any mix of days works.',
    weekComplete: 'This week’s pages reached. Any extra pages still count.',
    closePace: 'Close to pace, about {{count}} a day so far.',
    onPace: 'On pace, about {{count}} a day so far.',
    aheadPace: 'Ahead of pace, about {{count}} a day so far.',
    gentlePace: 'Every page counts. Read at your own pace.',
    beforeGoal: 'Before your goal',
    notCounted: '{{count}} · not counted',
    soFar: 'so far',
    upcoming: 'coming up',
    byToday: '{{count}} pages by today',
    allReading: 'All reading in {{year}}',
    historyNotBacklog: 'Earlier reading is history, never a backlog.',
    towardGoal: 'Toward your goal · {{count}}',
    priorHistory: 'Before your goal · {{count}}',
    loggedDays: '{{month}} · progress on {{count}} days',
    loggedDays_one: '{{month}} · progress on {{count}} day',
    loggedDays_other: '{{month}} · progress on {{count}} days',
    loggedDays_few: '{{month}} · progress on {{count}} days',
    loggedDays_many: '{{month}} · progress on {{count}} days',
    tapDay: 'Tap a day to see what added up',
    weeklyPages: '{{count}} pages this week',
    booksToGo_one: '{{count}} book to go',
    booksToGo_other: '{{count}} books to go',
    goalReached: 'Goal reached',
    booksPace: 'One book every {{count}} weeks keeps you on track.',
    noGoal: 'Your reading, at your pace',
    noGoalBody: 'Choose books a year or pages a day. Your reading history is always here.',
    setGoal: 'Set a reading goal',
    emptyBody: 'Your first page update or finished book will appear in your calendar.',
    targetEdit: 'New targets apply from today. Earlier days keep their original pace.',
    options: 'Reading goal options',
    editGoal: 'Edit goal',
    trackWithoutGoal: 'Track without a goal',
    turningOff: 'Switching to reading without a goal…',
    turnOffFailed: 'Could not turn off your goal. Try again.',
  },
  sk: {
    journey: {
      thisWeek: 'tento týždeň',
      ofTarget: 'z {{target}}',
      bySunday: 'Do nedele ešte {{count}} strán',
      weekReached: 'Týždenný cieľ splnený',
      todayProgress: 'Dnes {{current}} z {{target}}',
      noGoalHistory:
        'Tento týždeň máš zaznamenaných {{count}} strán. História zostáva v každom prípade.',
      pagesAccessibility:
        'Čitateľský cieľ: {{current}} zo {{target}} strán tento týždeň, dnes {{today}} z {{daily}}',
      pace: { ahead: 'V predstihu', on: 'Podľa tempa', behind: 'Trochu pozadu' },
      booksRhythm_one: '~{{count}} strana denne',
      booksRhythm_few: '~{{count}} strany denne',
      booksRhythm_many: '~{{count}} strany denne',
      booksRhythm_other: '~{{count}} strán denne',
      booksAhead: 'Máš náskok',
      booksSoFar_one: '{{count}} kniha tento rok',
      booksSoFar_few: '{{count}} knihy tento rok',
      booksSoFar_many: '{{count}} knihy tento rok',
      booksSoFar_other: '{{count}} kníh tento rok',
      booksGoalTarget_one: 'Cieľ: {{count}} kniha',
      booksGoalTarget_few: 'Cieľ: {{count}} knihy',
      booksGoalTarget_many: 'Cieľ: {{count}} knihy',
      booksGoalTarget_other: 'Cieľ: {{count}} kníh',
      booksCount_one: '{{current}} / {{count}} kniha',
      booksCount_few: '{{current}} / {{count}} knihy',
      booksCount_many: '{{current}} / {{count}} knihy',
      booksCount_other: '{{current}} / {{count}} kníh',
      readingDays: 'Dni s čítaním tento týždeň: {{count}}',
    },
    edit: 'Upraviť',
    ofBooks: 'z {{target}} kníh',
    title: 'Čitateľský cieľ',
    books: 'Knihy za rok',
    pages: 'Strany za deň',
    historyKept: 'Zmena cieľa zachová celú históriu čítania.',
    booksInYear: 'kníh v roku {{year}}',
    pagesPerDay: 'strán za deň',
    average: 'Je to priemer. Niekedy viac, inokedy menej.',
    exact: 'Zadať presné číslo',
    keyboard: 'Otvorí číselnú klávesnicu.',
    booksRange: 'Zadaj číslo od 1 do 999.',
    pagesRange: 'Zadaj kladné celé číslo.',
    invalidPages: 'Vyber celé číslo od 1 do 1 000 000.',
    finishedSoFar: 'Zatiaľ dokončené: {{count}}',
    rulerHint: 'Posunutím uprav hodnotu. Ťuknutím zadaj číslo.',
    done: 'Hotovo',
    save: 'Uložiť cieľ',
    addsUp: 'Spolu za',
    week: 'Týždeň',
    month: 'Mesiac',
    year: 'Rok',
    equivalent: '{{count}} strán · {{range}}',
    starts: 'Začína {{date}}. Nič nemusíš doháňať.',
    existingStart: 'Počíta sa od {{date}}. Skoršie čítanie zostáva v histórii.',
    whatCounts: 'Čo sa počíta?',
    everyPage: 'Počíta sa každá zaznamenaná strana zo všetkých kníh a aktualizácií.',
    flexible: 'Je to priemer. Dlhšie čítanie môže vyvážiť pokojnejší deň.',
    late: 'Zapisuješ neskôr? Strany sa počítajú v deň uloženia.',
    noTimers: 'Bez časovačov a sedení. Stačí zaznamenávať strany ako doteraz.',
    gotIt: 'Rozumiem',
    calendar: 'Kalendár čítania',
    openMonth: 'Otvoriť {{month}}',
    today: 'Dnes',
    ofPages: '{{current}} z {{target}} strán',
    dailyPace: '{{count}} strán denne',
    bySunday: 'Do nedele ešte {{count}} strán. Rozlož si ich podľa seba.',
    weekComplete: 'Týždenný cieľ splnený. Každá ďalšia strana sa počíta.',
    closePace: 'Blízko tempa, zatiaľ približne {{count}} denne.',
    onPace: 'Podľa tempa, zatiaľ približne {{count}} denne.',
    aheadPace: 'Nad tempom, zatiaľ približne {{count}} denne.',
    gentlePace: 'Každá strana sa počíta. Čítaj svojím tempom.',
    beforeGoal: 'Pred nastavením cieľa',
    notCounted: '{{count}} · nezapočítané',
    soFar: 'zatiaľ',
    upcoming: 'nasleduje',
    byToday: '{{count}} strán do dneška',
    allReading: 'Všetko čítanie v roku {{year}}',
    historyNotBacklog: 'Skoršie čítanie je história, nikdy nie dlh.',
    towardGoal: 'K cieľu · {{count}}',
    priorHistory: 'Pred cieľom · {{count}}',
    loggedDays: '{{month}} · pokrok počas {{count}} dní',
    loggedDays_one: '{{month}} · pokrok počas {{count}} dňa',
    loggedDays_other: '{{month}} · pokrok počas {{count}} dní',
    loggedDays_few: '{{month}} · pokrok počas {{count}} dní',
    loggedDays_many: '{{month}} · pokrok počas {{count}} dňa',
    tapDay: 'Ťukni na deň a pozri si podrobnosti',
    weeklyPages: '{{count}} strán tento týždeň',
    booksToGo_one: 'Zostáva {{count}} kniha',
    booksToGo_few: 'Zostávajú {{count}} knihy',
    booksToGo_many: 'Zostáva {{count}} knihy',
    booksToGo_other: 'Zostáva {{count}} kníh',
    goalReached: 'Cieľ splnený',
    booksPace: 'Jedna kniha každých {{count}} týždňov stačí na dosiahnutie cieľa.',
    noGoal: 'Tvoje čítanie, tvoje tempo',
    noGoalBody: 'Vyber si knihy za rok alebo strany za deň. História čítania tu vždy zostane.',
    setGoal: 'Nastaviť čitateľský cieľ',
    emptyBody: 'Prvý záznam strán alebo dokončená kniha sa objaví v kalendári.',
    targetEdit: 'Nový cieľ platí od dneška. Skoršie dni si zachovajú pôvodné tempo.',
    options: 'Možnosti čitateľského cieľa',
    editGoal: 'Upraviť cieľ',
    trackWithoutGoal: 'Sledovať bez cieľa',
    turningOff: 'Prepínanie na čítanie bez cieľa…',
    turnOffFailed: 'Cieľ sa nepodarilo vypnúť. Skús to znova.',
  },
  cs: {
    journey: {
      thisWeek: 'tento týden',
      ofTarget: 'z {{target}}',
      bySunday: 'Do neděle ještě {{count}} stránek',
      weekReached: 'Týdenní cíl splněn',
      todayProgress: 'Dnes {{current}} z {{target}}',
      noGoalHistory:
        'Tento týden máš zaznamenaných {{count}} stránek. Historie zůstává v každém případě.',
      pagesAccessibility:
        'Čtenářský cíl: {{current}} ze {{target}} stránek tento týden, dnes {{today}} z {{daily}}',
      pace: { ahead: 'V předstihu', on: 'Podle tempa', behind: 'Trochu pozadu' },
      booksRhythm_one: '~{{count}} strana denně',
      booksRhythm_few: '~{{count}} strany denně',
      booksRhythm_many: '~{{count}} strany denně',
      booksRhythm_other: '~{{count}} stran denně',
      booksAhead: 'Máš náskok',
      booksSoFar_one: '{{count}} kniha letos',
      booksSoFar_few: '{{count}} knihy letos',
      booksSoFar_many: '{{count}} knihy letos',
      booksSoFar_other: '{{count}} knih letos',
      booksGoalTarget_one: 'Cíl: {{count}} kniha',
      booksGoalTarget_few: 'Cíl: {{count}} knihy',
      booksGoalTarget_many: 'Cíl: {{count}} knihy',
      booksGoalTarget_other: 'Cíl: {{count}} knih',
      booksCount_one: '{{current}} / {{count}} kniha',
      booksCount_few: '{{current}} / {{count}} knihy',
      booksCount_many: '{{current}} / {{count}} knihy',
      booksCount_other: '{{current}} / {{count}} knih',
      readingDays: 'Dny se čtením tento týden: {{count}}',
    },
    edit: 'Upravit',
    ofBooks: 'z {{target}} knih',
    title: 'Čtenářský cíl',
    books: 'Knihy za rok',
    pages: 'Stránky za den',
    historyKept: 'Změna cíle zachová celou historii čtení.',
    booksInYear: 'knih v roce {{year}}',
    pagesPerDay: 'stránek za den',
    average: 'Je to průměr. Někdy více, jindy méně.',
    exact: 'Zadat přesné číslo',
    keyboard: 'Otevře číselnou klávesnici.',
    booksRange: 'Zadej číslo od 1 do 999.',
    pagesRange: 'Zadej kladné celé číslo.',
    invalidPages: 'Vyber celé číslo od 1 do 1 000 000.',
    finishedSoFar: 'Zatím dokončeno: {{count}}',
    rulerHint: 'Posunutím uprav hodnotu. Klepnutím zadej číslo.',
    done: 'Hotovo',
    save: 'Uložit cíl',
    addsUp: 'Celkem za',
    week: 'Týden',
    month: 'Měsíc',
    year: 'Rok',
    equivalent: '{{count}} stránek · {{range}}',
    starts: 'Začíná {{date}}. Nic nemusíš dohánět.',
    existingStart: 'Počítá se od {{date}}. Dřívější čtení zůstává v historii.',
    whatCounts: 'Co se počítá?',
    everyPage: 'Počítá se každá zaznamenaná stránka ze všech knih a aktualizací.',
    flexible: 'Je to průměr. Delší čtení může vyvážit klidnější den.',
    late: 'Zapisuješ později? Stránky se počítají v den uložení.',
    noTimers: 'Bez časovačů a sezení. Stačí zaznamenávat stránky jako dosud.',
    gotIt: 'Rozumím',
    calendar: 'Kalendář čtení',
    openMonth: 'Otevřít {{month}}',
    today: 'Dnes',
    ofPages: '{{current}} z {{target}} stránek',
    dailyPace: '{{count}} stránek denně',
    bySunday: 'Do neděle ještě {{count}} stránek. Rozlož si je podle sebe.',
    weekComplete: 'Týdenní cíl splněn. Každá další stránka se počítá.',
    closePace: 'Blízko tempu, zatím přibližně {{count}} denně.',
    onPace: 'Podle tempa, zatím přibližně {{count}} denně.',
    aheadPace: 'Nad tempem, zatím přibližně {{count}} denně.',
    gentlePace: 'Každá stránka se počítá. Čti svým tempem.',
    beforeGoal: 'Před nastavením cíle',
    notCounted: '{{count}} · nezapočítáno',
    soFar: 'zatím',
    upcoming: 'následuje',
    byToday: '{{count}} stránek do dneška',
    allReading: 'Všechno čtení v roce {{year}}',
    historyNotBacklog: 'Dřívější čtení je historie, nikdy ne dluh.',
    towardGoal: 'K cíli · {{count}}',
    priorHistory: 'Před cílem · {{count}}',
    loggedDays: '{{month}} · pokrok během {{count}} dní',
    loggedDays_one: '{{month}} · pokrok během {{count}} dne',
    loggedDays_other: '{{month}} · pokrok během {{count}} dní',
    loggedDays_few: '{{month}} · pokrok během {{count}} dní',
    loggedDays_many: '{{month}} · pokrok během {{count}} dne',
    tapDay: 'Klepni na den a prohlédni si podrobnosti',
    weeklyPages: '{{count}} stránek tento týden',
    booksToGo_one: 'Zbývá {{count}} kniha',
    booksToGo_few: 'Zbývají {{count}} knihy',
    booksToGo_many: 'Zbývá {{count}} knihy',
    booksToGo_other: 'Zbývá {{count}} knih',
    goalReached: 'Cíl splněn',
    booksPace: 'Jedna kniha každých {{count}} týdnů stačí k dosažení cíle.',
    noGoal: 'Tvoje čtení, tvoje tempo',
    noGoalBody: 'Vyber si knihy za rok nebo stránky za den. Historie čtení tu vždy zůstane.',
    setGoal: 'Nastavit čtenářský cíl',
    emptyBody: 'První záznam stránek nebo dokončená kniha se objeví v kalendáři.',
    targetEdit: 'Nový cíl platí ode dneška. Dřívější dny si zachovají původní tempo.',
    options: 'Možnosti čtenářského cíle',
    editGoal: 'Upravit cíl',
    trackWithoutGoal: 'Sledovat bez cíle',
    turningOff: 'Přepínání na čtení bez cíle…',
    turnOffFailed: 'Cíl se nepodařilo vypnout. Zkus to znovu.',
  },
};
